import { createFileRoute } from '@tanstack/react-router';
import { BookingRequestsPage } from '../../features/shipments';

export const Route = createFileRoute('/portal/shipments/booking')({ component: BookingRequestsPage });
